import { useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';

// Actions
import {
  updateUpdateAiSettingTemplateSection,
  removeUpdateAiSettingTemplateSection,
} from 'Shared/actions/UpdateAiSettings.actions';

// Types
import { UpdateAiTemplateSectionType } from 'Shared/types/UpdateAiTemplate.type';

type Props = {
  updateAiSettingSlug: string;
  section: UpdateAiTemplateSectionType;
};

export const useUpdateAiTemplateSection = ({ updateAiSettingSlug, section }: Props) => {
  const dispatch = useDispatch();

  const debouncedUpdate = useRef(
    debounce(data => {
      dispatch(
        updateUpdateAiSettingTemplateSection({
          slug: updateAiSettingSlug,
          templateSectionSlug: section.slug,
          data,
        })
      );
    }, 250)
  ).current;

  const handleUpdateTemplateWithDebounce = ({ data }) => {
    debouncedUpdate(data);
  };

  const handleUpdateTemplate = ({ data }) => {
    return dispatch(
      updateUpdateAiSettingTemplateSection({
        slug: updateAiSettingSlug,
        templateSectionSlug: section.slug,
        data,
      })
    );
  };

  const handleRemoveTemplateSection = useCallback(() => {
    dispatch(removeUpdateAiSettingTemplateSection({ slug: updateAiSettingSlug, templateSectionSlug: section.slug }));
  }, []);

  return { handleUpdateTemplate, handleUpdateTemplateWithDebounce, handleRemoveTemplateSection };
};
